// extracted by mini-css-extract-plugin
module.exports = {"header":"BasicContentFullWidthEmbed_header__DxWGx","search-fade-in":"BasicContentFullWidthEmbed_search-fade-in__w4iqK"};